export default "__VITE_ASSET__dc59534e__"